import { format } from "date-fns";
import {
	type CalendarPartInterface, 
	type RotationInterface,
	type CrewMemberInterface
} from "@/types/Calendar";
import { Button } from "@/components/ui/button";


type Props = {
	calendarDataGroup: {rotations: RotationInterface[]}[] | CrewMemberInterface[] | undefined,
	pageHandler: (page: {dir: string, currentPage: number | undefined}) => void,
	page: undefined | number,
	isLoading: boolean,
	maxPages: number,
	startDate: string | undefined,
	startDateHandler: (date: string) => void
};

export const CalendarControls = ({
	calendarDataGroup,
	pageHandler,
	page,
	isLoading,
	maxPages,
	startDate,
	startDateHandler
}: Props) => {
    const getRotationsDayChanges = (calendarDataGroup: {rotations: RotationInterface[]}[] | CrewMemberInterface[] | undefined) => {
		if(!calendarDataGroup) return;
		const rotations = calendarDataGroup.map(({rotations}: {rotations: RotationInterface[]}) => {
			return rotations.map(({calendar}: {calendar: CalendarPartInterface[]}) => {
				return calendar.reduce((acc: string[], {type, start_date}) => {
					if(["change_day", "travel_day_change_day"].includes(type)) {
						acc.push(format(start_date, "yyyy-MM-dd"));
					}
					return acc;
				}, [])
			});
		});

		const uniqueDates = Array.from(new Set(rotations.flat(2)));
		const sortedIntoYears = uniqueDates.reduce((acc: {[key: string]: string[]}, date: string) => {
			const year = new Date(date).getFullYear();
			if(!acc[year]) {
				acc[year] = [date];
			} else {
				acc[year].push(date);
			}
			return acc;
		}, {});
		const sortedKeys = Object.keys(sortedIntoYears).sort((a, b) => Number(a) - Number(b));
		const preparedDates = sortedKeys.map((year) => sortedIntoYears[year]);
		
		return preparedDates;
	};

	return (
		<div className="mb-3 relative sticky top-0 z-10 w-full bg-white pt-4">
			<div className="flex h-24">
				<div className="grow flex justify-between">
					<div className="me-3 h-[68px] pb-2 flex items-end">
						<Button disabled={(page ? (page <= 1) : true) || isLoading} onClick={ () => pageHandler({dir: "prev", currentPage: page})}>
							Previous
						</Button>
					</div>
			
					<div className="grow relative">	
						<div className="absolute w-full flex justify-center">

							<div className="flex scroll overflow-x-auto">
								{ getRotationsDayChanges(calendarDataGroup)?.map((dates: string[], index: number, arr: string[][]) => (
									<div key={index} className={`pb-2 ${ arr.length === 1 ? "" : index === 0 ? "pe-3" : "ps-3 pb-2 border-l-2" }`}>
										
										<div className={`text-xs font-semibold mb-1 ${ arr.length === 1 ? "text-center" : index === 0 ? "text-end" : "text-start" }`}>
											{new Date(dates[0]).getFullYear()}
										</div>

										<div className="flex items-center">
											{dates.map((date: string) => (
												<Button key={date} className={`me-1 last:me-0 ${ date === startDate ? "bg-orange-500" : "" }`} onClick={() => startDateHandler(date)}>
													{new Date(date).toLocaleDateString("en-GB", { day: "numeric", month: "short"})}
												</Button>
											))}
										</div>
										
										
									</div>
								
								))}
							</div>

						</div>
					</div>

					<div className="ms-3 h-[68px] pb-2 flex items-end">
						<Button disabled={(page ? (page >= maxPages) : true) || isLoading} onClick={ () => pageHandler({dir: "next", currentPage: page})}>
							Next
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
